/**
* Represents Kentico Cloud's field types
*/
export class FieldType {

    static text = new FieldType('text');
    static number = new FieldType('number');
    static modular_content = new FieldType('modular_content');
    static asset = new FieldType('asset');
    static datetime = new FieldType('date_time');
    static rich_text = new FieldType('rich_text');
    static multiple_choice = new FieldType('multiple_choice');
    static url_slug = new FieldType('url_slug');
    static taxonomy = new FieldType('taxonomy');
    constructor(public type: string) {
    }

    toString() {
        return this.type;
    }
}
